<div class="col-sm-12" id="pgmJourFerie" style="height: 100%; padding-top: 5px;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-7 fiche-client">
        <div> Facturation </div>
      </div>
      <button class="uppercase" id="savecont" (click)="save()"> Enregistrer </button>
      <button class="uppercase btn-close" id="closeclt" (click)="showFiche()"> Fermer </button>
    </div>
  </div>
  <div class="contente ligneBon col-sm-12" style="color: #000;padding: 15px 0; font-size: 13px;">
    <div class="col-sm-12 form-group" style="padding:  0 5px">
      <label class="col-sm-4"> Type de location : </label>
      <div class="col-sm-8">
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
          [(ngModel)]="facturation.isLocImmediat">
          <mat-radio-button [color]="'primary'" class="example-radio-button" [value]="false">
            Facturé Périodiquement
          </mat-radio-button>
          <mat-radio-button [color]="'primary'" class="example-radio-button" [value]="true">
            Facturé au Retrait
          </mat-radio-button>
        </mat-radio-group>
      </div>

    </div>

    <div class="col-sm-12 form-group" style="padding:  0 5px">
      <label class="col-sm-4"> Période de location : </label>
      <div class="col-sm-8">
        <app-autocomplete (selectfunction)="facturation.periodeLoc = $event;" [results]="periodeLocation"
          [highlight]="true" [isCombo]="true" id="typeOperation" [defaultselected]="facturation.periodeLoc"
          [defaultsearch]="facturation.periodeLoc ? facturation.periodeLoc.libelleObjetEntite : ''">
        </app-autocomplete>
      </div>
    </div>
    <div class="col-sm-12 form-group" style="padding:  0 5px">
      <label class="col-sm-4"> Type de Facturation : </label>
      <div class="col-sm-8">
        <app-autocomplete (selectfunction)="facturation.typeFact = $event;" [results]="typeFacturation"
          [highlight]="true" [isCombo]="true" id="typeOperation" [defaultselected]="facturation.typeFact"
          [defaultsearch]="facturation.typeFact ? facturation.typeFact.libelleObjetEntite : ''">
        </app-autocomplete>
      </div>
    </div>
    <div class="col-sm-12 form-group" style="padding:  0 5px">
      <label class="col-sm-12">
        <div class="col-sm-8">Tarif de la location : </div>
      </label>
      <div class="col-sm-12">
        <div class="col-sm-3">
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            [(ngModel)]="facturation.isTarifLoc">
            <mat-radio-button [color]="'primary'" class="example-radio-button" [value]="false">
              Standard
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="col-sm-3" style="padding-top: 7px;">
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            [(ngModel)]="facturation.isTarifLoc">
            <mat-radio-button [color]="'primary'" class="example-radio-button" [value]="true">
              Particulière
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-sm-3">
          <input type="number" class="form-control" [(ngModel)]="facturation.tarifLoc" />
        </div>
        <div class="col-sm-2" style="padding: 0; padding-top: 7px;">
          à partir de :
        </div>
        <div class="col-sm-2" style="padding: 0;">
          <input type="number" class="form-control" [(ngModel)]="facturation.nbrRotTarifLoc" />
        </div>
        <div class="col-sm-2"  style="padding-top: 7px;">
          rotation(s)
        </div>
      </div>
    </div>
    <div class="col-sm-12 form-group" style="padding:  0 5px">
      <label class="col-sm-12">
        <div class="col-sm-8">Tarif de la rotation : </div>
      </label>
      <div class="col-sm-12">
        <div class="col-sm-3">
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            [(ngModel)]="facturation.isTarifRot">
            <mat-radio-button [color]="'primary'" class="example-radio-button" [value]="false">
              Standard
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="col-sm-3" style="padding-top: 7px;">
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            [(ngModel)]="facturation.isTarifRot">
            <mat-radio-button [color]="'primary'" class="example-radio-button" [value]="true">
              Particulière
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-sm-3">
          <input type="number" class="form-control" [(ngModel)]="facturation.tarifRot" />
        </div>
      </div>
    </div>
    <div class="col-sm-12 form-group" style="padding:  0 5px">
      <label class="col-sm-4"> Nbr rot gratuite : </label>
      <div class="col-sm-8">
        <input type="number" class="form-control" [(ngModel)]="facturation.nbrRotGratuite" />
      </div>
    </div>
    <div class="col-sm-12 form-group" *ngIf="societe.commentairesFact" style="padding:  0 5px">
      <label class="col-sm-4"> Commentaires : </label>
      <div class="col-sm-8">
        <textarea class="form-control" rows="3" [(ngModel)]="facturation.commentairesFact"></textarea>
      </div>
    </div>
  </div>
</div>